import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_CONFIGURATION_TOKEN } from '../app-configuration';
import { IPatientRepository } from './Ipatient.repository';
import { ApiResponse, Patient, Plan } from './models';


@Injectable({ providedIn: 'root' })
export class PatientRepository implements IPatientRepository {

	private readonly httpClient = inject(HttpClient);
	private readonly configs = inject(APP_CONFIGURATION_TOKEN);


	getPlan(planGuid: string): Observable<ApiResponse<Plan>> {
		const params = new HttpParams().set('id', planGuid);
		return this.httpClient.get<ApiResponse<Plan>>(this.configs.domainPatientAPI + '/api/cases/getcase', { params });
	}

	getPatient(patientGuid: string): Observable<ApiResponse<Patient>> {
		const params = new HttpParams().set('id', patientGuid);
		return this.httpClient.get<ApiResponse<Patient>>(this.configs.domainPatientAPI + '/api/patients/getpatient', { params });
	}

}
